import { render, staticRenderFns } from "./AlertDestinationEditor.vue?vue&type=template&id=245a555e&scoped=true&lang=pug"
import script from "./AlertDestinationEditor.vue?vue&type=script&lang=ts"
export * from "./AlertDestinationEditor.vue?vue&type=script&lang=ts"
import style0 from "./AlertDestinationEditor.vue?vue&type=style&index=0&id=245a555e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a555e",
  null
  
)

export default component.exports